import { useRestMutation } from 'api/wrappers';
import { getApiUrl } from 'utils/config';
import { getApiStringFromDate } from 'utils/date';
const createAccountTermination = async (params) => {
    return fetch(`${getApiUrl()}/api/v1/accounts/termination`, {
        body: JSON.stringify(params),
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
    });
};
export const getAccountTerminationMutationOptions = (params) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- We only need to pull type from params
    const { date, type, ...rest } = params;
    if (date) {
        return {
            ...rest,
            date: getApiStringFromDate(date),
        };
    }
    return rest;
};
export const useAccountTerminationMutation = () => {
    return useRestMutation(createAccountTermination);
};
const createAccountTerminationConfirmation = async (params) => {
    return fetch(`${getApiUrl()}/api/v1/accounts/confirm_termination`, {
        body: JSON.stringify(params),
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
    });
};
export const getAccountTerminationConfirmationMutationOptions = (params) => {
    return {
        id: params.get('id') ?? '',
        token: params.get('token') ?? '',
    };
};
export const useAccountTerminationConfirmationMutation = () => {
    return useRestMutation(createAccountTerminationConfirmation);
};
